import React, { useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Checkbox, Collapse, FormControlLabel, IconButton, Paper, Stack, Typography } from '@mui/material';

import { InternalRoom, InternalService } from '~/services/AccommodationService';

import { titleCase } from '~/utils/stringUtils';

import SupplierRoomListElement from './SupplierRoomListElement';

interface Props {
  room: InternalRoom;
  isSelected: boolean;
  internalService: InternalService;
  onSelect: (internalRoomId: string, selected: boolean) => void;
}

export default function InternalRoomElement({ room, isSelected, internalService, onSelect }: Props) {
  const [isSourceRoomsExpanded, setIsSourceRoomsExpanded] = useState(false);

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        backgroundColor: !isSelected ? 'grey.100' : undefined,
        borderColor: isSelected ? 'info.light' : undefined,
      }}
    >
      <FormControlLabel
        checked={isSelected}
        onChange={() => onSelect(room.id, !isSelected)}
        control={<Checkbox />}
        label={room.name}
        componentsProps={{ typography: { variant: 'h6' } }}
      />
      <Typography sx={{ m: '1rm' }}>
        <strong>Internal Service:</strong> {titleCase(internalService)}
      </Typography>
      {room.supplierRooms.length > 0 && (
        <>
          <Stack
            direction="row"
            alignItems="center"
            onClick={() => setIsSourceRoomsExpanded(!isSourceRoomsExpanded)}
            sx={{ cursor: 'pointer', mt: 1 }}
          >
            <Typography variant="body2">
              {room.supplierRooms.length} source room{room.supplierRooms.length !== 1 ? 's' : ''}
            </Typography>
            <IconButton size="small">{isSourceRoomsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}</IconButton>
          </Stack>
          <Collapse in={isSourceRoomsExpanded}>
            {room.supplierRooms.map((supplierRoom) => (
              <SupplierRoomListElement key={supplierRoom.id} supplierRoom={supplierRoom} />
            ))}
          </Collapse>
        </>
      )}
    </Paper>
  );
}
